import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ReferencePatentModel } from '../reference-patent-model';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { ReferencePatentWithOrder } from '../../types';

@injectable()
export class ReferencePatentModelImpl extends AbstractModel<ReferencePatentWithOrder[]> implements ReferencePatentModel {
    protected _modelData: ReferencePatentWithOrder[] = [];

    dispose(): void {
        this.update(() => []);
    }
}
